// based on https://docs.google.com/document/d/1CuDdyyptwcyPUZzB5jEPjaoPG0jTv4L-iycaPM2ylFI/edit#heading=h.hf6mwpc1l82p
// see also https://docs.google.com/document/d/1PszbMD2JgXitdGb3qnn7RrqXJokpWL1mOZDNbF3FNZI/edit#heading=h.br6gq6igc4wu
const BaseballPitchType = {
    Fastball: { key: 'FA', name: 'Fastball'}, // used by Stat Grab
    Changeup: { key: 'CH', name: 'Changeup'},
    Slider: { key: 'SL', name: 'Slider'},
    Curveball: { key: 'CU', name: 'Curveball'},
    Sinker: { key: 'SI', name: 'Sinker'},
    Splitter: { key: 'SP', name: 'Splitter'},
    Cutter: { key: 'FC', name: 'Cutter'},
    Knuckleball: { key: 'KN', name: 'Knuckleball'},
    Other: { key: 'OT', name: 'Other'},
    Unidentified: { key: 'UI', name: 'Unidentified'},
    FourSeamFastball: { key: 'FF', name: '4S Fastball'},
    TwoSeamFastball: { key: 'FT', name: '2S Fastball'},
    Forkball: { key: 'FK', name: 'Forkball'},
    Slurve: { key: 'SV', name: 'Slurve'},
    Screwball: { key: 'SC', name: 'Screwball'},
    CircleChangeup: { key: 'CC', name: 'Circle Changeup'},
    KnuckleCurve: { key: 'KC', name: 'Knuckleball Curve'},
    Eephus: { key: 'EP', name:  'Eephus'},
    Palmball: { key: 'PB', name:  'Palmball'},
    Pitchout: { key: 'PO', name:  'Pitchout'},
    Gyroball: { key: 'GB', name:  'Gyroball'},
    BreakingBall: { key: 'BB', name: 'Breaking Ball'}, // used by Stat Grab
    Offspeed: { key: 'OS', name: 'Offspeed'}, // used by Stat Grab
};

export default BaseballPitchType;
